// extracted by mini-css-extract-plugin
export var blue = "_3b-f";
export var brand = "_3b-b";
export var darkGrey = "_3b-e";
export var disabled = "_3b-6";
export var error = "_3b-7";
export var green = "_3b-g";
export var grey = "_3b-d";
export var icon = "_3b-0";
export var inherit = "_3b-a";
export var lightGrey = "_3b-c";
export var orange = "_3b-i";
export var pink = "_3b-k";
export var primary = "_3b-1";
export var purple = "_3b-l";
export var quaternary = "_3b-4";
export var quinary = "_3b-5";
export var red = "_3b-j";
export var secondary = "_3b-2";
export var success = "_3b-9";
export var tertiary = "_3b-3";
export var warning = "_3b-8";
export var white = "_3b-m";
export var yellow = "_3b-h";